import { createStrings } from '@utils/local';

export const companyStrings = createStrings({
  ja: {
    shipper: 'shipper',
    shipperAgent: 'shipper-代理',
    consignee: 'cnee',
    consigneeAgent: 'cnee-代理',
    memberRole: '会員種別',
    company: '会社',
    company_name: '会社名',
    created_at: '登録時間',
    approval_no: '申込番号',
    member_no: '会員番号',
    email: 'メール',
    principal_name: '客側担当者',
    principal_name2: '担当者名',
    salesperson_name: '営業担当者',
    principal: '担当者',
    staffExists: 'このメールアドレスは既に登録されています。',
    k04: 'K04',
    corporate_number: '法人番号',
    importer_code: '輸出入者符号',
    real_time_account: 'リアルタイム口座番号',
    deferred_payment_account: '延納番号',
    country: '国または地域',
    zip_code: '郵便番号',
    phone: '電話番号',
    address1: '住所1',
    address2: '住所2',
    fax: 'FAX番号',
    start_date: '設立年',
    representer_last_name: '代表者姓',
    representer_first_name: '代表者名',
    legal_capital: '資本金',
    industry: '業種',
    employee_count: '社員数',
    transaction_condition: 'お取引条件',
    transaction_condition_detail: 'お取引条件詳細',
    customer_service_grades: '航路サービスグレード',
    grade: '現在のグレード',
    next_grade: '新しいグレード',
    next_grade_update_date: '更新時間',
  },
});

export const allCompanyGrades = ['A', 'B', 'C', 'S', 'X'];
